<template>
    <div>
        <h3>{{slide.slide.title}}</h3>
        <div style="font-size: 125%;" v-html="sanitize(slide.slide.corpus)"></div>
        <ResourceGallery :resourceList="slide.slide.resources"></ResourceGallery>
        <hr>
        <div v-if="slideChangedSinceAttempt" class="question-review-change-notice">
            <b>NOTICE: Section has changed since this attempt!</b>
            <br>
        </div>
        <div style="display: table; margin: auto;">
            <div v-for="opt in slide.options" :key="opt.id" style="display: inline-block; float: left; clear: both;">
                <md-checkbox v-model="answer" :value="opt.id" :disabled="complete" class="md-primary">
                    {{opt.corpus}}
                    <span style="margin-left: 10px;" v-if="complete">
                        <md-icon style="color: green" v-if="slide.answer_option_id.includes(opt.id)">check</md-icon>
                        <span style="color: red" v-else>X</span>
                    </span>
                </md-checkbox>
                <br>
            </div>
        </div>
        <div v-if="complete">
            <hr>
            <h2>Feedback</h2>
            <hr>
            <h3>
                <span v-if="complete">
                    Score: {{this.scoreAnswer().toFixed(2)}}%
                </span>
            </h3>
            <span v-html="sanitize(slide.answer)"></span>
        </div>
        <CitationViewer :citations="slide.slide.citations" v-if="complete"/>
        <ResourceGallery :resourceList="slide.a_resources" v-if="complete"></ResourceGallery>
        <hr>
        <md-button class="md-raised md-primary" v-if="!complete" @click="submitAnswer">
            Submit
        </md-button>
        <md-button class="md-raised md-primary" v-if="complete" @click="$emit('setDone', [slide.slide.order, true])">
            Continue
        </md-button>
    </div>
</template>

<script>

import ResourceGallery from './Gallery.vue'
import CitationViewer from './CitationViewer.vue'
import hasher from "object-hash"

export default {
    props: {
        slide: {
            type: Object
        },
        attemptRecord: {
            type: Object
        },
        complete: {
            type: Boolean
        },
        sanitize: {
            type: Function
        },
    },
    data: function(){
        return {
            answer: [],
            slideChangedSinceAttempt: false, 
        }
    },
    components: {
        ResourceGallery,
        CitationViewer,
    },
    methods: {
        /**
         * submitAnswer checks to see that the question has been answered. Notifies if not, otherwise saves.
         */
        submitAnswer: function(){
            if(this.answer.length < 1 && this.slide.options && this.slide.options.length > 0) {
                this.$emit("notify", "Please select an answer and submit again!")
            }        
            else{
                this.slide.complete = true
                var performance = {
                    performance: {
                        "Checklist": this.answer,
                        "QHash": hasher(JSON.stringify(this.slide))
                    },
                    score: this.scoreAnswer(),
                }
                this.$emit('setDone', [this.slide.slide.order, false, performance])
            }
        },
        /**
         * scoreAnswer will go through the answers to a checklist question and provide a score.
         * Selecting an incorrect answer will work as if
         * returns {int} score out of 100
         */
        scoreAnswer: function() {
            var numCorrect = 0;
            for (var i = 0; i < this.answer.length; i++) {
                if(this.slide.answer_option_id.includes(this.answer[i])){
                    numCorrect++
                }
                else {
                    numCorrect--
                }   
            }
            return Math.max(100*numCorrect/this.slide.answer_option_id.length, 0)
        },
        loadAttemptAnswer: function(){
            if(this.attemptRecord && this.attemptRecord.performance && Object.keys(this.attemptRecord.performance).length != 0){
                if(this.attemptRecord.performance["Checklist"]){
                    this.answer = this.attemptRecord.performance["Checklist"]
                }
                this.slideChangedSinceAttempt = hasher(JSON.stringify(this.slide)) != this.attemptRecord.performance["QHash"]
            }
        }
    },
    watch: {
        "attemptRecord": function() {
            this.loadAttemptAnswer()
        }
    },
    mounted: function(){
        this.$nextTick(function () {
            this.loadAttemptAnswer()
        })
    }
}
</script>

<style scoped>
.md-field{
    max-width: 80%;
    margin: auto;
    margin-bottom: 40px;
}
</style>